import React, {HTMLAttributes, useState} from 'react';
import cn from 'classnames';
import {AccordionContent, AccordionHeadline, AccordionWrapper} from './Accordion.style';
import {generateIdentifier} from '../../utils/IdentityUtils';

export interface AccordionProps extends HTMLAttributes<HTMLDivElement> {
    readonly accordionHeadline: string;
    readonly accordionSubHeadline?: string;
    readonly startOpen?: boolean;
}

/**
 * @name Accordion
 * @description
 * Generic component to create show an accordion with header and closable content area
 */
export const Accordion = React.forwardRef<HTMLDivElement, AccordionProps>(
    ({accordionHeadline, accordionSubHeadline, startOpen, children}, ref) => {
        const [showContent, setShowContent] = useState(startOpen);

        const isOpen = cn('a-accordion', {
            'a-accordion--open': showContent
        });

        const icons = cn('a-icon a-accordion__headline-icon', {
            'boschicon-bosch-ic-up': showContent,
            'boschicon-bosch-ic-down': !showContent
        });

        return (
            <AccordionWrapper id={generateIdentifier()} ref={ref} className={isOpen}>
                <AccordionHeadline id={generateIdentifier()} className='a-accordion__headline'
                                   onClick={() => setShowContent(!showContent)}>
                    <div id={generateIdentifier()} className='a-accordion__headline-text highlight'>
                        {accordionHeadline}
                        <i id={generateIdentifier()} className='sub-headline'>{accordionSubHeadline}</i>
                    </div>
                    <div id={generateIdentifier()} className={icons} onClick={() => setShowContent(!showContent)}/>
                </AccordionHeadline>
                <AccordionContent id={generateIdentifier()}
                                  className='a-accordion__content'>
                    {children}
                </AccordionContent>
            </AccordionWrapper>
        );
    }
);

Accordion.displayName = 'Accordion';
